<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- <div class="supportedPayment">
      <div class="bannr">
        <p class="spTitle1">Partner With</p>
        <ul class="paymentICONLIST">
          <li v-for="(item, index) in imageSrcList" :key="index">
            <img :src="item.url" />
          </li>
          
        </ul>
      </div>
    </div> -->

    <div class="max">
      <!-- <div class="soild"></div> -->
      <div id="footerend" class="wrapper">
        <!-- <div class="footerlipalpay">
          <a v-for="(item,i) in footerlipalpay" :key="i" :href="item.url" target="_blank" class="footer_footer_link_2KfAV" :style="item.img?'background:'+item.img:''"></a>
        </div>
        <p class="footerlink">
          <a :href="footer_writer[0].url" class="footer_footer_link_2KfAV">{{footer_writer[0].text}}</a>
          &nbsp; |
          <a
            target="_blank"
            class="footer_footer_link_2KfAV"
            :href="footer_writer[1].url">{{footer_writer[1].text}}</a>
          &nbsp; |
          <a target="_blank" :href="footer_writer[2].url" class="footer_footer_link_2KfAV"> {{footer_writer[2].text}}</a>
          &nbsp; |
          <a href="https://play.google.com/store/apps/details?id=net.kilimall.shop" class="footer_footer_link_2KfAV">&nbsp; MOBILE APP</a>
          
        </p> -->
        <div class="footerlink">
          <span>Copyright {{yearTime}}</span>
          <a href="https://www.kilimall.co.ke" target="_blank" class="footer_footer_link_2KfAV">Kilimall</a>, All rights reserved.
        </div>
        <div class="footerlink">
          <a href="https://beian.miit.gov.cn" target="_blank" class="footer_footer_link_2KfAV footer_copyright_link_3IiLA">
            湘ICP备19002592号-3
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted } from 'vue';

const yearTime = ref(null)
const imageSrcList = [
  {
    code: 1,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_KCB.png'
  },
  {
    code: 2,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_mpesa.png'
  },
  {
    code: 3,
    url: 'https://image.kilimall.com/kenya/PcImages/static/loge_airtel.png'
  },
  {
    code: 4,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_KCB.png'
  },
  {
    code: 5,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_Ecobank.png'
  },
  {
    code: 6,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_CreditBank.png'
  },
  {
    code: 7,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_lipapay.png'
  },
  {
    code: 8,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_visa.png'
  },
  {
    code: 9,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_mastercard.png'
  },
  {
    code: 10,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_UnionPay.png'
  },
  {
    code: 11,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_ipay.png'
  },
  {
    code: 12,
    url: 'https://image.kilimall.com/kenya/PcImages/static/logo_visa.png'
  }
]

const footerlipalpay = [
  { img: 'https://www.kilimall.co.ke/templates/en/images/footerlipalpay/M.png', url: 'https://www.lipapay.com/mc.html' },
  { img: 'https://www.kilimall.co.ke/templates/en/images/footerlipalpay/T.png', url: 'https://www.lipapay.com/mc.html' },
  { img: 'https://www.kilimall.co.ke/templates/en/images/footerlipalpay/S.png', url: 'https://www.lipapay.com/mc.html' }

]
const footer_writer = [
  { text: 'MALL', url: 'https://www.kilimall.co.ke' },
  { text: 'Travel', url: 'https://www.kilimall.co.ke/index.php?act=static&amp;op=bookroom' },
  { text: 'SELLER', url: '/index.php?act=seller_login&amp;op=show_login' },
  { text: 'MOBILE APP', url: 'https://play.google.com/store/apps/details?id=net.kilimall.shop' },
  { text: 'iOS App', url: '/how-can-i-use-kilimall-app-on-iphone/' },
]

onMounted(() => {
  yearTime.value = new Date().getFullYear()
})

</script>

<style scoped>
  .supportedPayment {
    width: 1200px;
    border: 1px #eaeaea;
    margin-top: 30px;
    margin: auto;
  }
  .supportedPayment >>> .paymentICONLIST {
    display: flex;
  }
  .paymentICONLIST li {
    flex: 1;
  }
  .paymentICONLIST li img {
    width: 87px;
    height: 43px;
    display: block;
  }
  .spwrapper1 {
    font-size: 18px;
    font-weight: bold;
    padding: 29px 0px 20px 0px;
  }
  .supportedPayment .banner {
    width: 1200px;
    margin: 0 auto;
  }

  .spTitle1 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .soild {
    height: 1px;
    border-bottom: 1px solid #eaeaea;
    margin-top: 30px;
  }
  .wrapper{
    padding:0 0 30px;
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    font-weight: 400;
    color: #333;
    line-height: 16px;
  }

  #footerend a:hover {
    color: #000;
    text-decoration: underline;
  }
  .footerlipalpay a {
    display: inline-block;
    height: 45px;
    width: 90px;
    margin-right:10px;
  }
  .footerlipalpay .box {
    margin: 0 auto;
    background: #f3f5f9;
    border: 0;
  }

  .footerlink {
    margin: 20px 0;
    font-size: 14px;
    color: #150000;
  }

  .footer_footer_link_2KfAV {
    color: #150000;
  }

  .footerlipalpay a:nth-of-type(1) {
    background: url(https://image.kilimall.com/kenya/PcImages/footerlipalpay/M.png) no-repeat;
  }
  .footerlipalpay a:nth-of-type(2) {
    background: url(https://image.kilimall.com/kenya/PcImages/footerlipalpay/T.png) no-repeat;
  }
  .footerlipalpay a:nth-of-type(3) {
    background: url(https://image.kilimall.com/kenya/PcImages/footerlipalpay/S.png) no-repeat;
  }

  a:hover {
    color: #333;
  }
</style>
  